import axios from "axios"
import global from "../../../globalvar";

let state = {
    maintenanceList: []
};
let getters = {};
let mutations = {
    setMaintenanceList(state, maintenanceList) {
        state.maintenanceList = maintenanceList
    }
};
let actions = {
    async loadMaintenances({commit, dispatch, rootState}) {
        console.log(rootState);
        try {
            commit("appModule/startFetching", null, { root: true });
            let maintenanceList = (await axios.get(global.ApiBaseUrl +"/api/maintenance/maintenance/all", {
                headers: {
                    "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
                }
            })).data;
            commit("appModule/endFetching", null, { root: true })
            commit("setMaintenanceList", maintenanceList)
        } catch (e) {
            dispatch("appModule/addErrorMessage", e, { root: true } )
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}